<template>
  <div v-if="filterForm">
    <a-card size="small" title="筛选条件" class="fixed-card">
      <a-form-model class="search-form" layout="inline" label-align="left">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="迭代">
              <a-select v-model="filterForm.version_id" allow-clear placeholder="迭代" style="width: 230px" @change="onVersionChange">
                <a-select-option v-for="version in versions" :key="version.id" :value="version.id">{{ version.title }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col v-if="false" :span="6">
            <a-form-model-item label="团队">
              <a-select v-model="filterForm.team" allow-clear placeholder="团队" style="width: 230px" @change="onTeamChange">
                <a-select-option v-for="team in teams" :key="team.id" :value="team.id">{{ team.name }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="">
              <a-checkbox :checked="filterForm.today_update" @change="onChange">今日更新</a-checkbox>
              <a-button v-tc="{ name: '搜索' }" type="primary" @click="onSearch">搜索</a-button>
              <a-button v-tc="{ name: '截图' }" type="dashed" style="margin-left: 5px" @click="screenshot">截图</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <div>
      <a-row>
        <a-card title="迭代概览" class="overview-card">
          <div style="display: flex; flex-wrap: wrap; justify-content: space-between">
            <p class="overview-text" style="">
              投入研发
              <span class="animated-number2">{{ animatedUserLength }}</span>
              人
            </p>
            <div>
              <a-tag v-for="team in verisonSpend.team" :key="team" class="tag" style="margin-right: 5px">{{ team }}</a-tag>
            </div>
            <p class="overview-text">
              总共研发任务点 <span class="animated-number">{{ animatedNumber }}</span>
            </p>
          </div>
        </a-card>
      </a-row>
    </div>
    <div ref="wholePage" class="diagram">
      <a-row :gutter="[16, 16]">
        <a-col class="customer-col" :span="8" style="padding-left: 8px !important">
          <version-diagram ref="diagramPie" :filter-form="filterForm" />
        </a-col>
        <a-col class="customer-col" :span="8">
          <VersionDevComplete ref="devPie" :filter-form="filterForm" />
        </a-col>
        <a-col class="customer-col" :span="8" style="padding-right: 8px !important">
          <VersionTestComplete ref="testPie" :filter-form="filterForm" />
        </a-col>
        <a-col class="customer-col" :span="24">
          <TaskDailyStatus ref="dailyTask" :filter-form="filterForm" />
        </a-col>
        <a-col class="customer-col" :span="24">
          <task-list ref="taskLists" :filter-form="filterForm" />
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import TaskDailyStatus from './components/TaskDailyStatus';
import VersionDiagram from './components/VersionDiagram';
import VersionDevComplete from './components/VersionDevCompleteChart';
import VersionTestComplete from './components/VersionTestCompleteChart';
import TaskList from '@/pages/data/diagram/components/TaskList';
import { versionList } from '@/api/project/version';
import { teamList } from '@/api/system/team';
import html2canvas from 'html2canvas';
import { getVersionSpend } from '@/api/data/task';

export default {
  components: { VersionDiagram, TaskDailyStatus, TaskList, VersionDevComplete, VersionTestComplete },
  data() {
    return {
      animatedNumber: 0,
      animatedUserLength: 0,
      duration: 1000, // 动画持续时间，以毫秒为单位
      labelCol: { span: 5 },
      version_id: null,
      user_group: null,
      verisonSpend: {
        user: [],
        team: [],
        point: 0
      },
      teams: [],
      versions: [],
      filterForm: {
        version_id: null,
        user_group: null,
        today_update: false
      }
    };
  },
  computed: {
    number() {
      // 计算过渡动画的结束值
      return this.verisonSpend.point;
    },
    userLength() {
      // 计算过渡动画的结束值
      return this.verisonSpend.user.length;
    }
  },
  watch: {
    number(newValue, oldValue) {
      // 监听数字变化并触发动画
      this.animateNumber(oldValue, newValue);
    },
    userLength(newValue, oldValue) {
      // 监听人数变化并触发动画
      this.animateUserLength(oldValue, newValue);
    }
  },
  mounted() {
    this.getVersionList();
    this.getTeamList();
    this.getSpend();
  },
  methods: {
    animateNumber(startValue, endValue) {
      let startTime = null;
      const step = timestamp => {
        if (!startTime) startTime = timestamp;
        const progress = timestamp - startTime;
        this.animatedNumber = Math.round(this.easeInOutCubic(progress, startValue, endValue - startValue, this.duration));
        if (progress < this.duration) {
          requestAnimationFrame(step);
        }
      };
      requestAnimationFrame(step);
    },
    animateUserLength(startValue, endValue) {
      let startTime = null;
      const step = timestamp => {
        if (!startTime) startTime = timestamp;
        const progress = timestamp - startTime;
        this.animatedUserLength = Math.round(this.easeInOutCubic(progress, startValue, endValue - startValue, this.duration));
        if (progress < this.duration) {
          requestAnimationFrame(step);
        }
      };
      requestAnimationFrame(step);
    },
    easeInOutCubic(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t * t + b;
      t -= 2;
      return (c / 2) * (t * t * t + 2) + b;
    },
    onVersionChange(value) {
      this.filterForm.version_id = value;
    },
    onTeamChange(value) {
      this.filterForm.user_group = value;
    },
    onSearch() {
      this.$emit('change');
      this.$refs.diagramPie.getDiagramData();
      this.$refs.devPie.getDiagramData();
      this.$refs.testPie.getDiagramData();
      this.$refs.taskLists.getDiagramData();
      this.$refs.dailyTask.getData();
      this.getSpend();
    },

    // 获取项目列表
    getVersionList() {
      versionList({ project_id: 1 }).then(res => {
        this.versions = res.data.list;
        this.filterForm.version_id = res.data.list[0].id;
        this.onSearch();
      });
    },
    getTeamList() {
      teamList({}).then(res => {
        this.teams = res.data.items;
      });
    },
    getSpend() {
      getVersionSpend(this.filterForm).then(res => {
        this.verisonSpend = res.data;
      });
    },
    onChange(e) {
      this.filterForm.today_update = e.target.checked;
    },
    screenshot() {
      const that = this;
      html2canvas(this.$refs.wholePage, {
        backgroundColor: null,
        useCORS: true,
        scale: 1.2,
        ignoreElements: function (element) {
          if (element.classList && (element.classList.contains('ant-pagination') || element.classList.contains('issues-today'))) {
            return true;
          } else {
            return false;
          }
        }
      }).then(canvas => {
        canvas.toBlob(blob => {
          const data = [new ClipboardItem({ [blob.type]: blob })];
          navigator.clipboard.write(data).then(
            () => {
              that.$message.success('已保存到粘贴板');
            },
            () => {
              that.$message.warning('保存截图失败');
            }
          );
        }, 'image/png');
      });
    }
  }
};
</script>
<style lang="less" scoped>
.overview-card {
  padding-top: 100px;
  width: 100%; // 设置卡片宽度为100%
}

.overview-heading {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 8px;
}

.overview-text {
  font-size: 20px;
  margin-bottom: 4px;
  margin-left: 200px;
}
.animated-number {
  display: inline-block;
  transition: 0.3s;
  font-weight: bold;
  margin-right: 200px;
}
.animated-number2 {
  display: inline-block;
  transition: 0.3s;
  font-weight: bold;
}
.tag {
  margin-right: 4px; // 调整标签之间的间距
  margin-bottom: 4px; // 调整标签与其他内容之间的间距
}
.customer-col {
  margin-top: 16px;
}
.fixed-card {
  position: fixed;
  top: 50px; /* 设置卡片距离顶部的距离 */
  left: 215px; /* 设置卡片距离左侧的距离 */
  width: 90.5%;
  z-index: 999;
}

/deep/ .ant-col-8 {
  padding-left: 3px !important;
  padding-right: 3px !important;
}
</style>
